var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Tooltip',{attrs:{"transfer":"","content":!_vm.is_face_imgs?_vm.$t('l.remark65'):_vm.$t('l.remark66'),"placement":"top"}},[_c('Avatar',{staticStyle:{"height":"26px","width":"26px","font-size":"16px"},style:({backgroundColor:!_vm.is_face_imgs?'':'#3399ff'}),attrs:{"shape":"square","size":"small","icon":"ios-person"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }